import { Box, Flex } from '@everlywell/ui-kit';
import { motion } from 'framer-motion';
import React from 'react';

import { useEntranceAnimations } from '../hooks/useEntranceAnimations';
import type { EvaWelcomeScreenProps } from '../types/components';
import ChatMessageInput from './ChatMessageInput';
import EvaGreetingMessage from './EvaGreetingMessage';

import EvaTrustBar from './EvaTrustBar';
import EvaAgentAvatar from './internal/EvaAgentAvatar';

export default function EvaWelcomeScreen({
  value,
  onChange,
  onSubmit,
  isDisabled,
}: EvaWelcomeScreenProps): JSX.Element {
  const animations = useEntranceAnimations();

  return (
    <Flex
      as={motion.div}
      variants={animations.container}
      initial="hidden"
      animate="show"
      minHeight="100svh"
      width="100%"
      paddingX={[4, 32, 48]}
      paddingTop={[4, 32]}
      paddingBottom={[4, 32]}
      flexDirection="column"
      alignItems="center"
      justifyContent={["flex-start", "center"]}
      textAlign="center"
    >
      <Box
        as={motion.div}
        variants={animations.logo}
        marginTop={['auto', 0]}
        marginBottom={["12px", 0]}
        display={['flex', 'block']}
        justifyContent={['center', 'initial']}
        width={['100%', 'auto']}
      >
        <EvaAgentAvatar size={[48, 48]} />
      </Box>

      <Box
        as={motion.div}
        variants={animations.heading}
        maxWidth="50rem"
      >
        <EvaGreetingMessage />
      </Box>

      <Box
        as={motion.div}
        variants={animations.footer}
        width="100%"
        display="flex"
        justifyContent="center"
        order={[2, 4]}
        marginTop={['90px', '122px']}
        marginBottom={['auto', 0]}
      >
        <EvaTrustBar />
      </Box>

      <Box
        as={motion.div}
        variants={animations.promptBar}
        width="100%"
        display="flex"
        justifyContent="center"
        order={[3, 2]}
      >
        <ChatMessageInput
          value={value}
          onChange={onChange}
          onSubmit={onSubmit}
          isDisabled={isDisabled}
        />
      </Box>

      <Box order={[4, 3]} marginTop={['24px', 0]} />
    </Flex>
  );
}
